<template lang="pug">
  Header(fixed)
    SidebarToggler.d-lg-none(display="md" mobile)
    SidebarToggler.d-md-down-none(display="lg")
    b-navbar-brand(to="/").justify-content-start
      span.navbar-brand-full {{ $t("message.app.full") }}
      span.navbar-brand-minimized {{ $t("message.app.minimized") }}
    b-navbar-nav.ml-auto
      //- NavbarLanguage.d-lg-none
      Alert(:alert="isError" :randomKey="randomKey" v-if="isError && $store.getters.alertOn == true").mx-2
      a.fas.fa-bell.fa-lg.text-info(href="javascript:void(0)" @click="toStatusPage").mr-1
      span.badge.badge-pill.badge-info(:class="{ 'blink': sboErrorCount > 0 || ibcErrorCount > 0}") {{ sboErrorCount + ibcErrorCount }}
      AsideToggler.aside.d-md-down-none(display="lg")
    vue-snotify
</template>

<script>
import { Header, SidebarToggler, AsideToggler } from "@/library/coreui";
import NavbarLanguage from "@/library/NavbarLanguage";
import _ from "lodash";
import Alert from '@/library/Alert';
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  components: {
    Header,
    SidebarToggler,
    NavbarLanguage,
    AsideToggler,
    Alert
  },
  data: () => ({
    timerId: null,
    refreshTime: 10,
    refreshUpdate: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    errorRobot: false,
    sboErrorCount: 0,
    ibcErrorCount: 0,
    alertKey: '',
    reportList: [],
  }),
  computed: {
    randomKey() {
      return this.alertKey;
    },
    isError() {
      return this.errorRobot;
    },
  },
  created: function() {
    this.$options.refreshEnabled = true;
  },
  mounted: function() {
    this.startCountDownRefresh();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    forceRerenderAlert: function() {
      this.alertKey = Math.random().toString(36).replace('0.', '');
    },
    toStatusPage: function() {
      this.$router.push("/monitor/status");
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getReportList();
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();

          if (this.sboErrorCount > 0 || this.ibcErrorCount > 0) { //only withdraw trans will alert now
            this.errorRobot = true;
            this.forceRerenderAlert();
          } else {
            this.errorRobot = false;
          }
        }, this.refreshTime * 1000);
      }
    },
    getReportList: function() {
      let url = config.statusListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.status
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.reportList = response.data.reports;
                this.reportList = _.orderBy(this.reportList, ["payload.success", "bot.id"], ["asc"]);
                this.reportList = _.groupBy(this.reportList, "target.provider_id");
                // console.log(this.reportList);
                //testing
                // for(var i = 0; i < this.reportList['IBC'].length; i++) {
                //   if(i % 2 == 0)
                //     this.reportList['IBC'][i].payload.success = false;
                // }
                if (this.reportList['SBO'] && this.reportList['IBC']) {
                  this.ibcErrorCount = this.reportList['IBC'].filter(item => { return item.payload.success == false; }).length;
                  this.sboErrorCount = this.reportList['SBO'].filter(item => { return item.payload.success == false; }).length;

                  // this.errorRobot = isIBCError || isSBOError;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            console.log(error);
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            if (!this.feedback.status.includes('No connection is available to service this operation'))
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          if (!this.feedback.status.includes('No connection is available to service this operation'))
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  },
};
</script>
<style lang="scss">
.badge {
  padding: 2.5px 4px !important;
}
.blink {
  -webkit-animation: blinking 1.5s ease infinite; /* Safari 4+ */
  -moz-animation: blinking 1.5s ease infinite; /* Fx 5+ */
  -o-animation: blinking 1.5s ease infinite; /* Opera 12+ */
  animation: blinking 1.5s ease infinite; /* IE 10+, Fx 29+ */
}

@keyframes blinking {
  0% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
  50% {
    background-color: rgb(211, 98, 143);
    color: #ffffff;
  }
  100% {
    background-color: rgba(255, 255, 255, 0);
    color: rgb(211, 98, 143);
  }
}
</style>
